import { render, staticRenderFns } from "./appShare.vue?vue&type=template&id=2034fa2e&scoped=true&lang=pug"
import script from "./appShare.vue?vue&type=script&lang=js"
export * from "./appShare.vue?vue&type=script&lang=js"
import style0 from "./appShare.vue?vue&type=style&index=0&id=2034fa2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034fa2e",
  null
  
)

export default component.exports